import { createFileRoute } from '@tanstack/react-router';
import { useEffect, useRef } from 'react';

import {
  OnboardingPopup,
  type OnboardingPopupHandle,
} from '#modules/user/features/onboarding/components/OnboardingPopup';
import { MyProfile } from '#modules/user/features/profile/components/MyProfile';
import type { ProfileAgendaView } from '#modules/user/features/profile/components/Profile/ProfileAgenda';

export const Route = createFileRoute('/{-$locale}/_layout/_dashboard/_authed/dashboard/profile')({
  validateSearch: (
    search: Record<string, unknown>
  ): { tab?: ProfileAgendaView; profileSaved?: boolean } => ({
    ...(search.tab === 'posts' || search.tab === 'sessions' || search.tab === 'favorites'
      ? { tab: search.tab }
      : {}),
    ...(search.profileSaved === true ? { profileSaved: true } : {}),
  }),
  component: ProfilePage,
});

function ProfilePage() {
  const { tab, profileSaved } = Route.useSearch();
  const navigate = Route.useNavigate();
  const onboardingPopupRef = useRef<OnboardingPopupHandle>(null);
  useEffect(() => {
    if (!profileSaved) return;
    onboardingPopupRef.current?.open();
    // Одноразовый показ после первого сохранения: перезагрузка и Back не открывают его снова.
    void navigate({ search: { tab }, replace: true, resetScroll: false });
  }, [profileSaved, navigate, tab]);
  return (
    <>
      <OnboardingPopup popupRef={onboardingPopupRef} />
      <MyProfile
        agendaView={tab ?? 'posts'}
        onAgendaViewChange={(view) => {
          void navigate({ search: { tab: view }, replace: true, resetScroll: false });
        }}
      />
    </>
  );
}
